import { Typography } from "@mui/material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { SurveyAppointmentSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/surveyAppointmentModels";
import { useTranslation } from "react-i18next";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: SurveyAppointmentSubtypeDataModel;
}

export default function SurveyAppointmentSubtypeSummary(props: Props) {
    const { t } = useTranslation();

    if (props.subtypeData.noEventViable) {
        return <Typography textOverflow={"ellipsis"}>{t("incentivationPage.surveyAppointment.noEventSelected")}</Typography>
    }

    return <Typography textOverflow={"ellipsis"}>{
        props.subtypeData.eventAnswers.map((e) => e.event.title).join(", ")
    }</Typography>
}
